<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">Klepet</h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body pt-3">
        <telm-chat [termData]="selectedTerm"></telm-chat>
    </div>
</div>
